/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { actualsVsPlanStatsSchema } from './actualsVsPlanStatsSchema';
import { groupedSchema } from './groupedSchema';

export const ungroupedSchema = z.object({
  get groups() {
    return z.union([z.array(groupedSchema), z.null()]).optional();
  },
  get stats() {
    return actualsVsPlanStatsSchema;
  },
  get ungrouped() {
    return z.union([ungroupedSchema, z.null()]).optional();
  },
});
